var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLaw105 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 105,
  height: 105,
  viewBox: "0 0 105 105",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32 92H73V93H32V92Z",
  fill: "var(--icon-decorative-coral)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M53 20V12H52V20H28.2427L8 48.3398V48.5C8 57.6121 15.3879 65 24.5 65C33.6121 65 41 57.6121 41 48.5V48.3974L29.2583 21H52V83H53V21H75.7417L64 48.3974V48.5C64 57.6121 71.3879 65 80.5 65C89.6121 65 97 57.6121 97 48.5V48.3398L76.7573 20H53ZM39.7417 48L28.3904 21.5136L9.47159 48H39.7417ZM9.00791 49C9.2719 57.3285 16.1074 64 24.5 64C32.8926 64 39.7281 57.3285 39.9921 49H9.00791ZM95.5284 48L76.6096 21.5136L65.2583 48H95.5284ZM65.0079 49H95.9921C95.7281 57.3285 88.8926 64 80.5 64C72.1074 64 65.2719 57.3285 65.0079 49Z",
  fill: "currentColor"
})));
export default SvgLaw105;